import $ from 'jquery'

export default {
    name: 'assure-admissions',
    components: {},
    props: {
        list_exclu_admissions: Array
    },
    data() {
        return {
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
            text_grey: []
        }
    },

    watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_ADMISSION', this.one_is_checked)
        }
    },

    computed: {
        tarif_admissions() {
            return this.$store.getters["tarif_admissions"];
        },
    },

    mounted() {
        this.listeAdmissions()
    },

    methods: {
        listeAdmissions() {
            const data = {
                assurance_id: 0,
                data_type: 'admission'
            }

            this.$store.dispatch('getTarificationTypeAdmission', data).then(() => {
                if (this.tarif_admissions.length > 0) {
                    this.setSelectedAdmissions()
                } 
            })
        },

        setSelectedAdmissions() {
			this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_admissions.forEach(exclusion => {
                this.tarif_admissions.forEach(admission => {
					if (exclusion.id == admission.id) {
                        this.text_grey[admission.id] = 'text-grey'
                        this.one_is_checked.push(admission.id)
                    } 
                });
            });
		},

        toutSelectionner() {
            let is_checked = $('#all-admission').is(":checked")
            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.tarif_admissions.forEach((admission) => {
                if (is_checked) {
                    this.one_is_checked.push(admission.id)
                }
                this.text_grey[admission.id] = (is_checked)?'text-grey':''
            });
            
            this.all_checked = is_checked
        },

        onExclu(index) {
            let is_checked = $('#admission'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
        },
    }
}